import type React from 'react';

import { PaypalButton } from 'src/app/shared/components/payments';

import { usePaypal } from './usePaypal';

type Props = {
	height?: number;
};

export const Paypal: React.FC<Props> = ({ height = 45 }) => {
	const params = usePaypal();
	return (
		<div className="w-full flex-1">
			<PaypalButton
				{...params}
				style={{ color: 'blue', label: 'paypal', height, borderRadius: 8 }}
				data-testid="paypal-button"
				data-qa="paypal-button"
			/>
		</div>
	);
};
